import { render, staticRenderFns } from "./SummaryItemEntries.vue?vue&type=template&id=32000256&scoped=true&"
import script from "./SummaryItemEntries.vue?vue&type=script&lang=js&"
export * from "./SummaryItemEntries.vue?vue&type=script&lang=js&"
import style0 from "./SummaryItemEntries.vue?vue&type=style&index=0&id=32000256&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32000256",
  null
  
)

export default component.exports